import { Box, Typography, Link } from '@mui/material'
import BarChartIcon from '@mui/icons-material/BarChart'

import { color } from 'config/color'
import { ADMIN_CONTACT_EMAIL } from 'config'

export const NoResults = (): JSX.Element => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" p={10}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="50%"
        gap={1}
      >
        <BarChartIcon
          sx={{
            color: color.grey[500],
            backgroundColor: color.grey[100],
            fontSize: 50,
            borderRadius: '50%',
            padding: 3
          }}
        />
        <Typography color={color.grey[900]} fontWeight={500} fontSize={24}>
          No Results Found
        </Typography>

        <Typography color={color.grey[700]} fontWeight={400} fontSize={16}>
          We couldn’t find anything with the given date. If you think this is an
          error please
          <Link
            ml={0.5}
            href={`mailto:${ADMIN_CONTACT_EMAIL}`}
            target="_blank"
            rel="noreferrer"
          >
            <Typography
              component="span"
              sx={{ textDecoration: 'underline' }}
              color={color.primary[600]}
              fontWeight={400}
              fontSize={16}
            >
              create a Jira ticket
            </Typography>
          </Link>
          {' and our support team will start working on a resolution.'}
        </Typography>
      </Box>
    </Box>
  )
}
